import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group cursor-pointer">
            <span className="text-2xl md:text-3xl font-heading text-primary-500">
              丫丫漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                isActive('/')
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            {categories.filter((c) => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                isActive('/about')
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl text-foreground-800`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer whitespace-nowrap">首页</Link>
            {categories.filter((c) => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}